import * as React from "react";
import { ModuleScreen } from "../../common/ModuleScreen";
import { WizardCameraScreen } from "./WizardCameraScreen";
import ErrorBoundary from "../../../ErrorBoundary";
import { fetchAddCameraInfo } from "../Sites/SitesPage/SitesPageUtils/fetchAddCameraInfo";
import { StatusNotificationScreen } from "../../common/StatusNotificationScreen";
import { useNavigate } from "react-router-dom";
import {
  buildAddCameraWizardResponse,
  readAddCameraInfoFromStorage,
  shouldRefreshAddCameraInfo,
  AddCameraWizardResponse,
} from "./buildAddCameraWizardResponse";

export const AddCamera = ({
  setCameraCheckFinsihedAlertOpen,
  setGoodCameras,
  setConnectivityCameras,
  setLowResolutionCameras,
  setCameraCheckResultDownloadURL,
}: {
  setCameraCheckFinsihedAlertOpen: any;
  setGoodCameras: any;
  setConnectivityCameras: any;
  setLowResolutionCameras: any;
  setCameraCheckResultDownloadURL: any;
}) => {
  const navigate = useNavigate();
  const [visibleScreen, setVisibleScreen] = React.useState(<></>);

  const showWizard = React.useCallback(
    (responseObject: AddCameraWizardResponse) => {
      setVisibleScreen(
        <ErrorBoundary>
          <WizardCameraScreen
            setVisibleScreen={setVisibleScreen}
            responseObject={responseObject}
            setCameraCheckFinsihedAlertOpen={setCameraCheckFinsihedAlertOpen}
            setGoodCameras={setGoodCameras}
            setConnectivityCameras={setConnectivityCameras}
            setLowResolutionCameras={setLowResolutionCameras}
            setCameraCheckResultDownloadURL={setCameraCheckResultDownloadURL}
          />
        </ErrorBoundary>
      );
    },
    [
      setCameraCheckFinsihedAlertOpen,
      setConnectivityCameras,
      setGoodCameras,
      setLowResolutionCameras,
      setCameraCheckResultDownloadURL,
    ]
  );

  React.useEffect(() => {
    // First time Add Camera loads (first camera): use API initial_data only.
    // copyValues is only set after "Submit and Add Another", so clear it on mount.
    localStorage.removeItem("copyValues");

    const siteId = localStorage.siteId;
    const cachedAddCameraInfo = readAddCameraInfoFromStorage();

    if (!shouldRefreshAddCameraInfo(cachedAddCameraInfo, siteId)) {
      showWizard(buildAddCameraWizardResponse(cachedAddCameraInfo));
      return;
    }

    setVisibleScreen(
      <StatusNotificationScreen
        styling="absolute first-line:font-black font-mulish text-[20px] right-[190px] text-center text-[#283E6D] top-80"
        text="Loading camera form..."
      />
    );

    fetchAddCameraInfo(String(siteId), navigate).then((data) => {
      const addCameraInfo = data ?? readAddCameraInfoFromStorage();
      showWizard(buildAddCameraWizardResponse(addCameraInfo));
    });
  }, [navigate, showWizard]);

  return (
    <ModuleScreen
      text="Add Camera"
      visibleScreen={visibleScreen}
      styling={
        "text-white absolute top-[1px] right-[450px] font-mulish text-[18px] p-3"
      }
    />
  );
};
